<style lang="scss" src="../styles/main.scss"></style>

<template src="./templates/StaticResource.html"></template>

<script>
const defaultText = `This page is not available right now. Please check back later.`

export default {
  name: 'StaticResource',
  data () {
    return {
      contentText: ''
    }
  },
  mounted () {
    let vm = this
    let resourceName = this.$router.currentRoute.path
    resourceName = resourceName.substring(1, resourceName.length).toLowerCase()
    vm.ResourcesService(vm).getResources(resourceName).then((response) => {
      let text = response[0] !== undefined ? response[0].text : null
      if (text) {
        vm.contentText = text
      } else {
        vm.contentText = defaultText
      }
    })
      .catch((error) => {
        console.log(error)
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/views/StaticResource.vue